import(/* webpackMode: "eager" */ "/var/www/html/iknotwebpageP/nextjs/src/component/SupplyChainAnalytics/page.js")